import { useEffect } from "react";
import { useGroupStore } from "../store/groupStore";

/** Loads the group into groupStore when a member-level screen is opened directly at its URL. */
export function useEnsureGroup(groupId: string) {
  const loadedId = useGroupStore((state) => state.group?.id ?? null);
  const loadState = useGroupStore((state) => state.loadState);
  const loadGroup = useGroupStore((state) => state.loadGroup);
  const isCurrent = loadedId === groupId;

  useEffect(() => {
    const current = useGroupStore.getState();
    if (current.group?.id === groupId && current.loadState.kind !== "idle") return;
    const controller = new AbortController();
    void loadGroup(groupId, controller.signal);
    return () => controller.abort();
  }, [groupId, loadGroup]);

  return {
    isReady: isCurrent && loadState.kind === "ready",
    isLoading: !isCurrent || loadState.kind === "loading",
    error: loadState.kind === "error" && !isCurrent ? loadState.message : null,
    retry: () => void loadGroup(groupId),
  };
}
